import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { BusinessTripFormResponse } from '@/types/apps/business-trip-form.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';
import { dateUtils } from '@/utils/date';

export interface BusinessTripFormServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type BusinessTripFormListResponse = GqlListResponse<BusinessTripFormResponse>;

export class BusinessTripFormGraphQLService
    extends BaseService
    implements BusinessTripFormServiceInterface
{
    public getEntityName(): string {
        return 'businessTripForm';
    }

    public getFields(): Record<string, any> {
        return {
            checkin: true,
            checkinPlan: true,
            checkout: true,
            checkoutPlan: true,
            code: true,
            createdBy: true,
            createdDate: true,
            customerId: true,
            description: true,
            id: true,
            isDeleted: true,
            status: true,
            technicalId: true,
            totalHour: true,
            customer: {
                name: true,
            },
            technical: {
                fullname: true,
            },
        };
    }

    public index(query: string): Promise<BusinessTripFormListResponse> {
        return this.fetchGqlList(query, this.getEntityName()).then(res => {
            return {
                ...res,
                items: res.items.map((item: any) => ({
                    ...item,
                    customName: `${item.code} (${dateUtils.getDateTimeLocal(item.checkinPlan)} - ${dateUtils.getDateTimeLocal(item.checkoutPlan)})`,
                })),
            };
        });
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('businessTripForm', {
            userId: this.getQueryById(),
        });
    }
}
